import Divider from '@componentPrimitives/Divider';
import Grid from '@componentPrimitives/Grid';
import Txt from '@componentPrimitives/Txt';
import { BlockContainer } from '@components/Blocks';
import CtaButton from '@components/CtaButton/CtaButton';
import Image from '@components/Image/Image';
import { createBlock } from '@lib/features/blocks';
import { useTranslations } from 'next-intl';
import React from 'react';

export type ProfileCardBlockProps = {
  /**/
};

const ProfileCardBlock = createBlock<'blocks_profileCard_BlockType'>(
  ({ heading, profileSingle: profile }) => {
    const t = useTranslations('cta');

    const withHeading = !!heading;
    if (!profile) return null;

    return (
      <BlockContainer maxWidth="md">
        <Divider />
        <Grid cx={{ pY: '3xl' }}>
          <Grid.Col offsetMd={4} md={8}>
            {withHeading && (
              <Txt as="h2" variant="body" cx={{ mB: '3xs' }}>
                {heading}
              </Txt>
            )}
          </Grid.Col>
          <Grid.Col md={4}>
            <Image alt={profile.title || ''} {...profile.entryImage} ratio="square" round rounded />
          </Grid.Col>
          <Grid.Col md={8}>
            <Txt as={withHeading ? 'h3' : 'h2'} autoMargin variant="h5">
              {profile.title}
            </Txt>
            <Txt as="p">{profile.entrySummary}</Txt>
            <CtaButton href={profile.uri} variant="outlined" size="small">
              {t('more')}
            </CtaButton>
          </Grid.Col>
        </Grid>
        <Divider />
      </BlockContainer>
    );
  }
);

export default ProfileCardBlock;
